import { FC, useState } from 'react';
import { LogoImage } from 'assets';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import LoanCalculatorSettings from '../LoanCalculatorSettings';
import Stepper from 'ui/components/Frame/Stepper/Stepper';
import styles from './SidebarSecondary.module.scss';
import useLoanApplicationProcess from '../LoanApplicationProcessProvider/useLoanApplicationProcess';

interface SidebarSecondaryProps {
  isCalculatorOpen: boolean;
  onCalculatorSettingsSubmit?: (amount: number) => void;
}

const SidebarSecondary: FC<SidebarSecondaryProps> = (props) => {
  const { isCalculatorOpen, onCalculatorSettingsSubmit } = props;
  const { t } = useTranslation();
  const { progress } = useLoanApplicationProcess();
  const [currentSectionId] = useState(() => progressToSection(progress));
  const sections = [
    {
      id: 'registration',
      title: t('registration'),
    },
    {
      id: 'identification',
      title: t('identification'),
    },
    {
      id: 'verification',
      title: t('verification'),
    },
  ];

  return (
    <div className={styles['left-panel-secondary']}>
      <div className={styles['logo']} data-test="css-Logo">
        <LogoImage />
      </div>
      <Stepper
        steps={sections.map(({ title }) => ({ text: title }))}
        currentStep={sections.findIndex(({ id }) => id === currentSectionId)}
        currentStepFinished={progress === 1}
        dataTest="css-Progressbar-Items"
      />
      <div
        className={classNames(
          styles['left-panel-secondary-overlay'],
          isCalculatorOpen
            ? styles['left-panel-secondary-overlay--opened']
            : undefined,
        )}
      >
        <LoanCalculatorSettings onSubmit={onCalculatorSettingsSubmit} />
      </div>
    </div>
  );
};

export default SidebarSecondary;

const progressToSection = (progress: number) => {
  if (progress === 0 || progress === 0.33) return 'registration';

  if (progress === 0.66) return 'identification';

  return 'verification';
};
